import { getCurrentSubdomain } from '@app/utils/getCurrentSubdomain'
import { BASE_API_URL } from '@app/app-constants'

/**
 * Debounce flag to prevent multiple redirects
 * being issued (then immediately cancelled by the browser)
 */
let isRedirecting = false

/**
 * Redirects the user through the necessarily login flow for the current
 * domain, returning to `redirectPath` if provided.
 *
 * @param redirectPath
 */
export default function loginRedirect(redirectPath?: string) {
  console.log('redirecting to login', { redirectPath, isRedirecting })
  if (isRedirecting) return
  isRedirecting = true

  const currentSubdomain = getCurrentSubdomain(
    window.location.hostname,
    import.meta.env.VITE_SAFE_DOMAIN ?? 'rex.local',
  )
  let loginUrl = new URL(`${BASE_API_URL}/auth/login`)
  if (currentSubdomain) {
    loginUrl.searchParams.append('client_name', currentSubdomain)
  }
  if (redirectPath) {
    loginUrl.searchParams.append('return_path', redirectPath)
  }
  window.location.href = loginUrl.toString()
}
